import HtmlContentWithMentions from '@components/mentions/HtmlContentWithMentions'
import StandardCard from '@components/StandardCard'
import { Recognition } from '@kudos/http-client'
import Chip from '@mui/material/Chip'
import Typography from '@mui/material/Typography'
import { ConfirmDialog } from '@shared/dialog/ConfirmDialog'
import RecognitionRecipientsTitle from '@tenant/recognition/RecognitionModal/DraftAndSchduledView/InProgressCard/RecognitionRecipientsTitle'
import { T } from '@transifex/react'
import { format, parseISO } from 'date-fns'
import useDraftAndScheduleActions from './useDraftAndScheduleActions'

type DraftAndScheduleCardProps = {
  recognition: Recognition
}
const DraftAndScheduleCard: React.FC<DraftAndScheduleCardProps> = ({ recognition }) => {
  const isScheduled = !!recognition.scheduledAt
  const { actions, deleteRecognitionConfirmDialog, handleConfirm } =
    useDraftAndScheduleActions(recognition)

  const scheduledDate = recognition.scheduledAt && parseISO(recognition.scheduledAt)
  const lastEdited = format(parseISO(recognition.updatedAt), 'MMM dd, yyyy')

  return (
    <>
      <StandardCard
        key={recognition.id}
        title={<RecognitionRecipientsTitle recipients={recognition.sendTo ?? []} />}
        chip={
          isScheduled ? (
            <Chip variant="info" size="small" component="div" label={<T _str="Scheduled" />} />
          ) : (
            <Chip variant="inactive" size="small" component="div" label={<T _str="Draft" />} />
          )
        }
        actions={actions}
        bottomLeftActions={
          <Typography variant="caption">
            {scheduledDate ? (
              <T
                _str="Scheduled for: {sendDate} at {sendTime}"
                sendDate={format(scheduledDate, 'MMM dd, yyyy')}
                sendTime={format(scheduledDate, 'h:mm aa')}
              />
            ) : (
              <T _str="Last edited: {lastEditDate}" lastEditDate={lastEdited} />
            )}
          </Typography>
        }>
        <HtmlContentWithMentions htmlContent={recognition.message} />
      </StandardCard>
      <ConfirmDialog
        dialogKey={deleteRecognitionConfirmDialog}
        title={<T _str="Are you sure you want to delete this recognition?" />}
        variant="danger"
        confirmButtonText={<T _str="Delete" />}
        cancelButtonText={<T _str="Keep" />}
        onConfirm={handleConfirm}
      />
    </>
  )
}

export default DraftAndScheduleCard
